import React, { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import { CampaignCard } from "../components/CampaignCard";
import { api } from "../lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { toast } from "sonner";
import { Bookmark, Download, Eye } from "lucide-react";

export default function MyCampaigns() {
  const [data, setData] = useState({ saved: [], imported: [], recently_viewed: [] });

  const load = () => api.get("/my-campaigns").then((r) => setData(r.data)).catch(() => {});
  useEffect(load, []);

  const toggleSave = async (c) => {
    try {
      if (c.is_saved) await api.delete(`/campaign/${c.id}/save`);
      else await api.post(`/campaign/${c.id}/save`);
      toast.success(c.is_saved ? "Removed from saved" : "Campaign saved");
      load();
    } catch {
      toast.error("Action failed");
    }
  };

  const Grid = ({ list, empty }) =>
    list.length === 0 ? (
      <div className="text-center py-16 text-zinc-500">{empty}</div>
    ) : (
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((c) => <CampaignCard key={c.id} campaign={c} onToggleSave={toggleSave} />)}
      </div>
    );

  return (
    <div className="min-h-screen grain">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="inline-flex px-2.5 py-1 rounded-full bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 text-[10px] font-mono uppercase tracking-widest mb-2">Free</div>
        <h1 className="font-display text-3xl font-bold mb-6">My Campaigns</h1>
        <Tabs defaultValue="saved">
          <TabsList className="bg-[#141419] border border-white/10">
            <TabsTrigger value="saved" data-testid="tab-saved"><Bookmark className="w-4 h-4 mr-1.5" /> Saved ({data.saved.length})</TabsTrigger>
            <TabsTrigger value="imported" data-testid="tab-imported"><Download className="w-4 h-4 mr-1.5" /> Imported ({data.imported.length})</TabsTrigger>
            <TabsTrigger value="viewed" data-testid="tab-viewed"><Eye className="w-4 h-4 mr-1.5" /> Recently viewed</TabsTrigger>
          </TabsList>
          <TabsContent value="saved" className="mt-6"><Grid list={data.saved} empty="No saved campaigns yet. Browse and save some." /></TabsContent>
          <TabsContent value="imported" className="mt-6"><Grid list={data.imported} empty="You haven't imported any campaigns yet." /></TabsContent>
          <TabsContent value="viewed" className="mt-6"><Grid list={data.recently_viewed} empty="No recently viewed campaigns." /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
